<sb-card [loading]="loading">
  <div card-body>
    <h3>{{'lang.globals.settings' | translate}}</h3>

    <form [formGroup]="settingsForm" (ngSubmit)="save()">
      <div class="mt-3">
        <div *ngFor="let key of formControlKeys" class="mt-4">
          <web-setting
            [key]="key"
            [setting]="webSettings[key]"
            [control]="getFormControl(key)">
          </web-setting>
        </div>
      </div>

      <div class="mt-5">
        <button class="btn btn-secondary" type="button" (click)="reset()">{{ 'lang.globals.reset' | translate }}</button>
        <button class="btn btn-primary" type="submit">{{ 'lang.globals.save' | translate }}</button>
      </div>
    </form>
  </div>
</sb-card>
